import { render, staticRenderFns } from "./FloatingMessage.vue?vue&type=template&id=33714c08&"
import script from "./FloatingMessage.vue?vue&type=script&lang=js&"
export * from "./FloatingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports